// document.querySelectorAll( '.b-megamenu-tab-item' ).forEach( ( block ) => {

// 	/////////////////////
// 	// BLOCK CODE HERE //
// 	/////////////////////

// } );
